module.exports = __webpack_public_path__ + "media/my_performance_en.7ebce5bb.mp4";